module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavysnow-60a2ace7992860eb84848c0b6ac219ef.png";